import { render, staticRenderFns } from "./SupplierAccountRequestsDialog.vue?vue&type=template&id=7f7b3d5a"
import script from "./SupplierAccountRequestsDialog.vue?vue&type=script&lang=js"
export * from "./SupplierAccountRequestsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports